import { he3Data } from './data_conversion/he3'
import { type MouseConfig } from './data_type/response'
import { bitsToByte, splitIntoBytes } from './tool'
import { HIDFromVk } from '../define/define_fn'
import { BaseDriver } from './device'
import { ResDeviceState } from '@libs/types/response'
import { DeviceConnectMode, SpecificItem } from '@libs/types/enum'
import type { DeviceProtocol } from '@hid/device/device_model'

export class he3Driver extends BaseDriver {
  updateFirmware(): Promise<boolean> {
    throw new Error('Method not implemented.')
  }

  async syncCustomColor() {}
  async syncDecorationLed() {}
  Magnet() {
    return null
  }
  async pair24g() {
    return 0
  }
  async setOrReadSpecificItem(item: SpecificItem) {
    if (item == SpecificItem.PowerLevel) {
      return await this.getPower()
    } else if (item == SpecificItem.PowerIsCharging) {
      return await this.getPowerIsCharging()
    }
  }

  async getKeys() {
    // let keys: { [index: VK]: MapKey } = {}
    // const res = await this.sendMsg(HE3CommunicationType.ReadKeyDefinitionArea)
    // let baseKeys = Object.keys(MouseBaseKeys)
    // for (let i = 0; i < 5; i++) {
    //     const index = baseKeys[i] as unknown as number
    //     keys[index] = he3Data.decodeKey([res[i * 4], res[i * 4 + 1], res[i * 4 + 2], res[i * 4 + 3]])
    // }
    // return keys
  }

  constructor(protocol: DeviceProtocol) {
    super(protocol)
  }

  async getVersion() {
    const res = await this.sendMsg(HE3CommunicationType.BaseInfo)
    const version = res[9] + '.' + res[8]
    return version
  }

  async getDeviceState(): Promise<ResDeviceState> {
    const sdType = this.isWireless ? HE3CommunicationType.HeartbeatDataWireLess : HE3CommunicationType.HeartbeatDataWire
    const data = await this.sendMsg(sdType)
    const res: ResDeviceState = {
      ConnectType: data[4] == DeviceConnectMode.M_USB ? DeviceConnectMode.M_USB : DeviceConnectMode.Wireless24G,
      IsSleep: false,
      IsConnect: data[6] == 0x11,
      // Power: data[5],
      // DeviceState: data[6],
    }
    return res
  }

  async getPower() {
    const sdType = this.isWireless ? HE3CommunicationType.HeartbeatDataWireLess : HE3CommunicationType.HeartbeatDataWire
    const data = await this.sendMsg(sdType)
    return data[5]
  }

  async getPowerIsCharging() {
    const sdType = this.isWireless ? HE3CommunicationType.HeartbeatDataWireLess : HE3CommunicationType.HeartbeatDataWire
    const data = await this.sendMsg(sdType)
    const IsConnect = data[6] == 0x11
    return IsConnect && data[4] == DeviceConnectMode.M_USB ? 1 : 0
  }

  async syncLeds() {
    this.sendMsg(HE3CommunicationType.WriteLedLightArea)
    const data = Array(64).fill(0)
    this.DeviceHID.send(data)
    this.endWrite() //结束通信
  }

  async syncKeys() {
    const keysData = this.save.Keys
    let data = Array(64).fill(0)
    if (keysData.length > 0) {
      //data = await this.sendMsg(HE3CommunicationType.ReadKeyDefinitionArea)
      keysData.forEach((value) => {
        const keyData = he3Data.encodeKey(value)
        const baseIndex = value.Input.KK * 4
        data[baseIndex + 0] = keyData[0]
        data[baseIndex + 1] = keyData[1]
        data[baseIndex + 2] = keyData[2]
        data[baseIndex + 3] = keyData[3]
      })
    }

    this.sendMsg(HE3CommunicationType.WriteKeyDefinitionArea)
    this.DeviceHID.send(data)
    this.endWrite() //结束通信

    this.clearResetKeys()
  }

  async reset() {
    await this.syncKeys()
    await this.syncConfig()
    await this.syncMacros()
  }

  async getMouseConfig() {
    const res = await this.sendMsg(HE3CommunicationType.ReadGameDefinitionArea)

    const config: MouseConfig = {
      LockAltTab: res[2] === 0x01,
      LockAltF4: res[3] === 0x01,
      LockWindows: res[4] === 0x01,
      ReportRate: res[16],
      DpiIndex: res[21],
      DpiCount: 0,
      DpiData: [],
    }

    for (let i = 0; i < 6; i++) {
      config.DpiData.push({
        Value: res[24 + i * 2] * 100,
        Rgb: [res[36 + i * 4], res[37 + i * 4], res[38 + i * 4]],
        Enable: !!((res[20] >> i) & 1),
      })
    }
    config.DpiCount = config.DpiData.length
    return config
  }

  async syncConfig() {
    const data = this.save.Mouse
    if (data.DpiList.length > 6) {
      data.DpiList = data.DpiList.slice(0, 6)
      data.DpiColors = data.DpiColors.slice(0, 6)
    }

    let setData = Array(64).fill(0)
    setData[0] = 10
    setData[1] = 1
    setData[2] = 0x00
    setData[3] = 0x00
    setData[4] = 0x00
    ;(setData[16] = he3Rates[data.Rate] ? he3Rates[data.Rate] : 0), (setData[20] = bitsToByte(Array(data.DpiList.length).fill(1)))
    setData[21] = data.DpiIndex

    for (let i = 0; i < data.DpiList.length; i++) {
      setData[24 + i * 2] = data.DpiList[i] / 100
      setData[24 + i * 2 + 1] = data.DpiList[i] / 100

      setData[36 + i * 4] = data.DpiColors[i][0]
      setData[37 + i * 4] = data.DpiColors[i][1]
      setData[38 + i * 4] = data.DpiColors[i][2]
      setData[39 + i * 4] = 0
    }

    setData[62] = 0xaa
    setData[63] = 0x55

    this.sendMsg(HE3CommunicationType.WriteGameDefinitionArea)
    this.DeviceHID.send(setData), this.endWrite()
    //return data
  }

  async syncMacros() {
    let sendData = Array(3072).fill(0)

    let keyStart = 400
    this.save.Macros.forEach((v, i) => {
      const [lowByte, highByte] = splitIntoBytes(keyStart)
      sendData[0 + i * 4] = lowByte
      sendData[1 + i * 4] = highByte

      const [lenLowByte, lenHighByte] = splitIntoBytes(v.length * 2 - 1)
      sendData[keyStart + 0] = lenLowByte
      sendData[keyStart + 1] = lenHighByte

      v.forEach((r, ri) => {
        const baseIndex = keyStart + 8 + ri * 8
        ;(sendData[baseIndex] = 0), (sendData[baseIndex + 1] = 0)
        sendData[baseIndex + 2] = HIDFromVk(r.Key)
        sendData[baseIndex + 3] = he3Data.encodeMacroType(SetActionType.Keyboard, r.Press ? 1 : 0)

        if (ri < v.length - 1) {
          let delay = r.Delay || 1
          let [delayLowByte, delayHighByte] = splitIntoBytes(delay)
          sendData[baseIndex + 4] = delayLowByte
          sendData[baseIndex + 5] = delayHighByte
          sendData[baseIndex + 6] = 0
          sendData[baseIndex + 7] = 80
        }
      })
      keyStart += (v.length * 2 - 1) * 4 + 8
    })

    const pages = Math.ceil(keyStart / 56)

    await this.sendMsg(HE3CommunicationType.DisableMouseCustomization)
    await this.sendMsg(HE3CommunicationType.WriteMacroArea, pages)
    for (let i = 0; i < pages; i++) {
      let setData = Array(64).fill(0)
      for (let l = 0; l < 64; l++) {
        setData[0 + l] = sendData[64 * i + l]
        if (i == pages - 1) {
          setData[62] = 170
          setData[63] = 85
        }
      }
      await this.DeviceHID.send(setData)
    }
    await this.endWrite()
    await this.syncKeys()
  }

  async syncDynamicColor(): Promise<boolean> {
    return true
  }
  private sendMsg(t: HE3CommunicationType, length?: number) {
    let len = length || 1
    return this.DeviceHID.send([0x04, t, 0, 0, 0, 0, 0, 0, len])
  }

  private endWrite() {
    this.DeviceHID.send([0x04, HE3CommunicationType.End])
  }
}

enum SetActionType {
  MouseButton = 0b001,
  MouseWheel = 0b010,
  Keyboard = 0b011,
  Delay = 0b101,
  Cursor = 0b110,
}

enum HE3CommunicationType {
  End = 0x02,
  BaseInfo = 0x05,
  ReadKeyDefinitionArea = 0x50,
  WriteKeyDefinitionArea = 0x51,
  ReadLedLightArea = 0x52,
  WriteLedLightArea = 0x53,
  ReadMacroArea = 0x54,
  WriteMacroArea = 0x55,
  ReadGameDefinitionArea = 0x56,
  WriteGameDefinitionArea = 0x57,
  EnableMouseCustomization = 0x58,
  DisableMouseCustomization = 0x59,

  HeartbeatDataWire = 0xaa,
  HeartbeatDataWireLess = 0xab,
}

const he3Rates: { [index: number]: number } = {
  1000: 2,
  500: 1,
  125: 0,
}
